module.exports = ":root{--lui-menu-max-menuitems:5;--lui-menu-menuitem-height:var(--lui-control-height);--lui-menu-width:none;--lui-menu-max-width:none;--lui-menu-min-width:none;--lui-menu-container-offset-vertical:6px}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-menu/theme/lui-menu.global.scss
// module id = 245
// module chunks = 0 1 3